/**
 * 
 * 
 * 
 */

export default {
    setPlayState({ commit }, state) {
        commit('SET_PLAY_STATE', state)
    },
    setGameOver({ commit }, state) {
        commit('SET_GAME_OVER', state)
    },
    setGameWin({ commit }, state) {
        commit('SET_GAME_WIN', state)
    },
    changeStage({ commit }, nextStage) {
        commit('CHANGE_STAGE', nextStage)
    },
    setTotalCount({ commit }, { matrixSquare, level }) {
        commit('SET_TOTAL_COUNT', { matrixSquare, level })
    },
    setBomb({ commit }, square) {
        commit('SET_BOMB', square)
    },
    setFlag({ commit }, square) {
        commit('SET_FLAG', square)
    },
    setFirstClickSquare({ commit }, square) {
        commit('SET_FIRST_SQUARE', square)
    },
    flipTotalCount({ commit }) {
        commit('FLIP_TOTAL_COUNT')
    },
    isShowMask({ commit }, maskState) {
        commit('IS_SHOW_MASK', maskState)
    },
    resetState({ commit }) {
        commit('RESET_STATE')
    }
}